import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import AllwaysCheckBoxPipelineProcessor from './AllwaysCheckBoxPipelineProcessor'
import CheckBoxSelectionPipeline from './CheckBoxSelectionPipeline'
import type { ISelectionContext } from './ISelectionContext'
import LegInCheckBoxPipelineProcessor from './LegInCheckBoxPipelineProcessor'
import RegularCheckBoxPipelineProcessor from './RegularCheckBoxPipelineProcessor'
import RovingBankerCheckBoxPipelineProcessor from './RovingBankerCheckBoxPipelineProcessor'

export default {
  process(
    current: IObservableStarter,
    all: ko.ObservableArray<IObservableStarter>,
    context: BettingInformation,
    selectionContext: ISelectionContext,
    count: number
  ): IObservableStarter[] {
    return new CheckBoxSelectionPipeline(
      new RegularCheckBoxPipelineProcessor(
        new RovingBankerCheckBoxPipelineProcessor(
          new AllwaysCheckBoxPipelineProcessor(new LegInCheckBoxPipelineProcessor(null))
        )
      )
    ).process(current, all, context, selectionContext, count)
  },
}
